import { calculateNights } from '.'

import { getCurrentIntl } from 'i18n/util/currentIntl'
import type {
  SavedAccommodationRentalData,
  SavedHotelData,
} from 'tripPlanner/types/tripItem'

export function getHotelRoomDescription(
  _unit: string = 'room',
  roomName?: string,
  rooms?: Array<App.Occupants>,
) {
  if (rooms && rooms.length > 0 && roomName) {
    const intl = getCurrentIntl()
    return intl.formatMessage({
      id: 'HYvjqjajz30q0Gu8RIcu',
      defaultMessage: '{roomName} ({count, plural, one {# room} other {# rooms}})',
      description: 'Hotel room name with number of rooms on the hotel or room booking page',
    }, { roomName, count: rooms.length })
  }

  return roomName
}

export const getAccommodationPriceAndLabel = (
  offer: App.Offer | App.BedbankOffer,
  savedItemData: SavedHotelData | SavedAccommodationRentalData,
) => {
  const intl = getCurrentIntl()
  const {
    checkIn,
    checkOut,
    price: savedPrice,
    value: savedValue,
  } = savedItemData
  const savedLuxPlusPrice =
    'luxPlusPrice' in savedItemData ? savedItemData.luxPlusPrice : undefined
  let price = savedPrice
  let value = savedValue
  let luxPlusPrice = savedLuxPlusPrice

  let priceLabel = intl.formatMessage({
    id: '2H0-6rsLz3iiIY8MoFQz',
    defaultMessage: 'From',
    description: 'Default price label for a saved accommodation item in the trip planner',
  })

  if (offer.type !== 'bedbank_hotel' && offer.bundledWithFlightsOnly) {
    if (offer.lowestPricePackage) {
      const basePrice = offer.lowestPricePackage.price
      const baseLuxPlusPrice = offer.lowestPricePackage.memberPrice
      const propertyFees = offer.lowestPricePackage.propertyFees
      priceLabel = intl.formatMessage({
        id: '-HRXB3KScv8daIFE9bYk',
        defaultMessage: '{count, plural, one {# night} other {# nights}} from',
        description: 'Duration in nights as accommodation price label in the trip planner',
      }, { count: offer.lowestPricePackage.duration })
      price = basePrice + propertyFees
      luxPlusPrice = baseLuxPlusPrice + propertyFees
    }

    if (offer.bundledWithFlightsOnly && savedItemData.flightBundle) {
      const savedFlightPrice = savedItemData.flightBundle.savedPrice

      if (
        savedItemData.flightBundle &&
        typeof price === 'number' &&
        typeof savedFlightPrice === 'number'
      ) {
        price += savedFlightPrice
        if (typeof luxPlusPrice === 'number') {
          luxPlusPrice += savedFlightPrice
        }
        if (typeof value === 'number') {
          value += savedFlightPrice
        }
      } else {
        // If `bundledWithFlightsOnly` is true, we *have* to show the price with flights for contractual reasons.
        // So if we don't have the flight price for whatever reason, then we just can't show the price here.
        price = undefined
        luxPlusPrice = undefined
        value = undefined
      }

      if (checkIn && checkOut) {
        const nights = calculateNights(checkIn, checkOut)
        if (nights) {
          priceLabel = intl.formatMessage({
            id: 'QPaXiXH6hY6hSTjzb2yc',
            defaultMessage: '{count, plural, one {# night} other {# nights}} + flights from',
            description: 'Duration in nights with flights as accommodation price label',
          }, { count: nights })
        }
      }
    }
  }

  return { price, luxPlusPrice, priceLabel, value }
}
